import {DatePicker, DatePickerProps} from "@mui/x-date-pickers";
import React, {useEffect, useState} from "react";
import {SetState} from "../../util/FormHandlers";
import dayjs, {Dayjs} from "dayjs";

export function DateField<Value extends string | undefined>({value, setValue, ...props}: {
    value: Value,
    setValue: SetState<Value>,
} & Omit<DatePickerProps, 'value' | 'onChange'>) {
    const [draft, setDraft] = useState<Dayjs | null>(
        () => value ? dayjs(value) : null,
    );

    useEffect(() => {
        setDraft(value ? dayjs(value) : null);
    }, [value]);

    const handleChange = (newValue: Dayjs | null) => {
        setDraft(newValue);

        if (newValue === null) {
            setValue(undefined as Value);
        } else if (newValue.isValid()) {
            setValue(newValue.format('YYYY-MM-DD') as Value);
        }
    };

    return (
        <DatePicker
            value={draft}
            onChange={handleChange}
            format="DD.MM.YYYY"
            {...props}
        />
    );
}
